import {
  SLOT_SIDE_BLOCKED_TIME_BACKGROUND_OFFSET_PER_SQUARE_LENGTH_REM,
  SLOT_SIDE_LENGTH_REM_SMALL,
} from 'constants/TableBasedTemplatesConstants';
import { StandardLonghandProperties, StandardShorthandProperties } from 'csstype';
import _ from 'lodash';

export const getBlockedSquareLeftPosition = (
  squaresToOffset: number
): Pick<StandardLonghandProperties, 'left'> => ({
  left: `${SLOT_SIDE_LENGTH_REM_SMALL * squaresToOffset}rem`,
});

export const getBlockedSquareWidth = (
  numTimeIntervalsInBlockRange: number
): Pick<StandardLonghandProperties, 'width'> => ({
  width: `${SLOT_SIDE_LENGTH_REM_SMALL * numTimeIntervalsInBlockRange - 0.1}rem`,
});

interface BlockedSquareBackgroundPositionArgs {
  isAdditionalInventory: boolean;
  rowIndex: number | undefined;
  squaresToOffset: number | undefined;
}
export function getBlockedSquareBackgroundPosition({
  isAdditionalInventory,
  rowIndex,
  squaresToOffset,
}: BlockedSquareBackgroundPositionArgs): Pick<StandardShorthandProperties, 'backgroundPosition'> {
  if (_.isUndefined(squaresToOffset)) {
    return { backgroundPosition: undefined };
  }

  const horizontalOffsetFromColumnCount =
    SLOT_SIDE_BLOCKED_TIME_BACKGROUND_OFFSET_PER_SQUARE_LENGTH_REM * squaresToOffset;

  let horizontalOffsetPerRow = SLOT_SIDE_BLOCKED_TIME_BACKGROUND_OFFSET_PER_SQUARE_LENGTH_REM;
  if (!isAdditionalInventory) {
    // Flex table rows have an additional 1px top/bottom border that separate each table row, whereas unassigned table rows do not. This made using the same calculation for both unassigned table rows + flex table rows not viable, as the background would appear to be ever-so-slightly jagged between rows for the table rows.
    // This extra offset accounts for that extra 1px border in flex table rows.
    horizontalOffsetPerRow -= 0.1;
  }
  const totalHorizontalOffsetFromRows = rowIndex ? rowIndex * horizontalOffsetPerRow : 0;

  const horizontalOffset = horizontalOffsetFromColumnCount + totalHorizontalOffsetFromRows;

  return {
    backgroundPosition: `left ${horizontalOffset}rem top 0`,
  };
}
